/**
 * Add functions for Google Analytics 4
 * */

(function (wpm, $, undefined) {

	wpm.getGA4OrderItems = function () {

		// "item_id"      : "34",
		// "item_name"    : "Hoodie",
		// "quantity"     : 1,
		// "item_brand"   : "",
		// "item_variant" : "Color: blue | Logo: yes",
		// "price"        : 45,
		// "currency"     : "CHF",
		// "item_category": "Hoodies"


		let orderItems = []

		for (const [key, item] of Object.entries(wpmDataLayer.order.items)) {

			let orderItem

			orderItem = {
				quantity     : item.quantity,
				price        : item.price,
				item_name    : item.name,
				currency     : wpmDataLayer.order.currency,
				item_category: wpmDataLayer.products[item.id].category.join("/"),
			}

			if (wpmDataLayer?.general?.variationsOutput && 0 !== item.variation_id) {

				orderItem.item_id      = String(wpmDataLayer.products[item.variation_id].dyn_r_ids[wpmDataLayer.pixels.google.analytics.id_type])
				orderItem.item_variant = wpmDataLayer.products[item.variation_id].variant_name
				orderItem.item_brand   = wpmDataLayer.products[item.variation_id].brand
			} else {

				orderItem.item_id    = String(wpmDataLayer.products[item.id].dyn_r_ids[wpmDataLayer.pixels.google.analytics.id_type])
				orderItem.item_brand = wpmDataLayer.products[item.id].brand
			}

			orderItems.push(orderItem)
		}

		return orderItems
	}

}(window.wpm = window.wpm || {}, jQuery))


/**
 * All event listeners
 * */


// view order received page event
jQuery(document).on("wpmOrderReceivedPage", function () {

	try {
		if (!wpmDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return
		if (wpmDataLayer?.pixels?.google?.analytics?.ga4?.mp_active) return
		if (!wpm.googleConfigConditionsMet("analytics")) return

		wpm.gtagLoaded().then(function () {
			gtag("event", "purchase", {
				send_to       : [wpmDataLayer.pixels.google.analytics.ga4.measurement_id],
				transaction_id: wpmDataLayer.order.number,
				affiliation   : wpmDataLayer.order.affiliation,
				currency      : wpmDataLayer.order.currency,
				value         : wpmDataLayer.order.value_regular,
				discount      : wpmDataLayer.order.discount,
				tax           : wpmDataLayer.order.tax,
				shipping      : wpmDataLayer.order.shipping,
				coupon        : wpmDataLayer.order.coupon,
				items         : wpm.getGA4OrderItems(),
			})
		})
	} catch (e) {
		console.error(e)
	}
})
